import React, { useState } from "react";
import SearchBarContext from "./SearchBarContext";

const SearchBarState = ({ children }) => {
  const [visible, setVisible] = useState(false);
  const [text, setText] = useState("");

  return (
    <SearchBarContext.Provider
      value={{
        searchBarText: text,
        setSearchBarText: setText,
        searchBarVisible: visible,
        setSearchBarVisible: setVisible,
      }}
    >
      {children}
    </SearchBarContext.Provider>
  );
};

export default SearchBarState;
